import Rover from '@rover/globals/Rover';
import $ from '@rover/globals/jquery';

const Clipboard = require('clipboard');

Rover.utils = Rover.utils || {};
Rover.utils.strings = Rover.utils.strings || {};

export const possessive = str => {
  if (str.slice(-1).toLowerCase() === 's') {
    return `${str}'`;
  }
  return `${str}'s`;
};

Rover.utils.capitalizeFirstLetter = s => s.charAt(0).toUpperCase() + s.slice(1);

Rover.utils.simpleSyndeticJoin = arr => arr.join(', ');

Rover.utils.getCsrfToken = () => {
  let csrfCookieName;
  const $meta = $('meta[name=csrf-cookie-name]');

  if ($meta.length > 0) {
    csrfCookieName = $meta.attr('content');
  } else {
    csrfCookieName = 'csrftoken';
  }

  return $.cookie(csrfCookieName);
};

export const copyTextToClipboard = (triggerSelector, successCallback) => {
  let callbackForSuccess = successCallback;
  if (typeof successCallback !== 'function') callbackForSuccess = () => {};
  const board = new Clipboard(triggerSelector);
  board.on('success', callbackForSuccess);
  board.on('error', () => {});
};

export default {
  possessive,
  copyTextToClipboard,
};



// WEBPACK FOOTER //
// ../utilities/string.js